import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

export const initialState = {
  bayonet_fingerprint_token: null,
  bayonetFingerprintToken: null,
  status: 'success',
  reasonCode: 0,
  reasonMessage: 'success',
};

const slice = createSlice({
  name: 'bayonet',
  initialState: reHydrateStore('bayonet') || initialState,
  reducers: {
    setBayonet: (state, { payload }) => payload,
  },
});

export const { setBayonet } = slice.actions;

export default slice.reducer;

export const selectCurrentBayonetToken = (state) => state.bayonet;
